export class FieldBase {
	public fieldId: string;
	public displayTitle: string;
	public databaseTitle: string;
	public rank: number;
}
